export function transformSelectedFlights(selectedFlights, flightDirections) {
    if (!selectedFlights.length) {
        return [];
    }
    const flightsMap = new Map();
    selectedFlights.forEach((selectedFlight, leg) => {
        var _a, _b;
        const flightsOnSegment = (_b = (_a = flightDirections[leg]) === null || _a === void 0 ? void 0 : _a.legs) !== null && _b !== void 0 ? _b : [];
        flightsOnSegment.forEach(flightOnLeg => flightOnLeg.pricesForFareGroups.forEach(fareGroup => {
            var _a, _b, _c;
            const fareGroupId = (_a = fareGroup.fareFamily) === null || _a === void 0 ? void 0 : _a.id;
            const flightKey = `${fareGroupId}/${leg}`;
            if (fareGroupId === selectedFlight.groupId &&
                fareGroup.prices.some(price => price.flight.id === selectedFlight.priceId)) {
                flightsMap.set(flightKey, {
                    fareGroupId,
                    fareName: fareGroup.fareFamily.title,
                    fareFamily: fareGroup.fareFamily,
                    flightInfo: flightOnLeg,
                    prices: [...((_c = (_b = flightsMap.get(fareGroupId)) === null || _b === void 0 ? void 0 : _b.prices) !== null && _c !== void 0 ? _c : []), ...fareGroup.prices]
                });
            }
        }));
    });
    return [...flightsMap.values()];
}
